import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { waLink } from "../lib/whatsapp";
import { Btn } from "../components/kit";

export const genPassword = () => {
  const a = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  const r = crypto.getRandomValues(new Uint32Array(10));
  return Array.from(r, (x) => a[x % a.length]).join("");
};

export function CredentialsDialog({ cred, onClose }) {
  const link = `${window.location.origin}/login`;
  const text = `Olá${cred.name ? `, ${cred.name}` : ""}! Seu acesso ao MapIA${cred.school ? ` (${cred.school})` : ""} está pronto.\n\nEndereço: ${link}\nLogin: ${cred.login}\nSenha: ${cred.password}\n\nNo primeiro acesso, troque a senha em "Trocar senha".`;
  const copy = async () => {
    await navigator.clipboard.writeText(text);
    toast.success("Login e senha copiados");
  };
  const wa = waLink(cred.whatsapp, text) || `https://wa.me/?text=${encodeURIComponent(text)}`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="credentials-dialog" className="w-[calc(100%-1.5rem)] rounded-xl">
        <DialogHeader><DialogTitle>Acesso do gestor criado</DialogTitle></DialogHeader>
        <div className="rounded-xl border bg-slate-50 p-4 space-y-2 text-sm">
          {cred.school && <div><span className="text-slate-500">Escola:</span> <b data-testid="credentials-school">{cred.school}</b></div>}
          <div><span className="text-slate-500">Endereço:</span> <b>{link}</b></div>
          <div><span className="text-slate-500">Login:</span> <b data-testid="credentials-login" className="font-mono">{cred.login}</b></div>
          <div><span className="text-slate-500">Senha:</span> <b data-testid="credentials-password" className="font-mono">{cred.password}</b></div>
        </div>
        <p className="text-xs text-slate-500">A senha só aparece agora. Envie para a escola e peça para trocá-la no primeiro acesso. Se perder, use “Senha” na aba Gestores para definir outra.</p>
        <DialogFooter className="flex-row flex-wrap justify-end gap-2">
          <Btn variant="outline" data-testid="credentials-copy" onClick={copy}><Copy className="w-4 h-4" />Copiar</Btn>
          <a href={wa} target="_blank" rel="noreferrer" data-testid="credentials-whatsapp" className="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-[#0B192C] hover:bg-slate-50"><MessageCircle className="w-4 h-4 text-green-600" />Enviar por WhatsApp</a>
          <Btn data-testid="credentials-close" onClick={onClose}>Concluir</Btn>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
